import { Menu } from 'antd';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { RouteConstants } from 'app/routes';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  generatePath,
  matchPath,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { MenuInfo } from 'types';

import FieldResourcesIcon from '../../../../icons/FieldResourcesIcon';
import MapFieldsIcon from '../../../../icons/MapFieldsIcon';
import { ITabMenuItem, TaskListTabType } from '../../../../slice/types';

interface IProps {}

const TasksAndRunsWithoutTaskSwitch: FC<IProps> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const envId = useSelector(selectSelectedEnvId) as number;

  const onTabClick = (clickedItem: MenuInfo) => {
    const key = clickedItem.key as TaskListTabType;
    if (key === 'runsWithoutTask') {
      history.push(
        generatePath(RouteConstants.task.routesWithoutTask, {
          envId,
        }),
      );
    } else {
      history.push(
        generatePath(RouteConstants.task.list, {
          envId,
        }),
      );
    }
  };

  const activeTab: TaskListTabType = matchPath(
    location.pathname,
    RouteConstants.task.list,
  )
    ? 'tasks'
    : 'runsWithoutTask';

  const menuItems: ITabMenuItem<TaskListTabType>[] = [
    {
      title: t('Task.List.TaskList', 'Task list'),
      icon: <MapFieldsIcon />,
      key: 'tasks',
    },
    {
      title: t('Task.List.RunsWithoutTask', 'Routes without task'),
      icon: <FieldResourcesIcon />,
      key: 'runsWithoutTask',
    },
  ];

  return (
    <Menu
      mode="inline"
      selectedKeys={[activeTab]}
      onClick={onTabClick}
      style={{ marginBottom: 12 }}
    >
      {menuItems.map(item => (
        <Menu.Item icon={item.icon} key={item.key} id={item.id}>
          {item.title}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default TasksAndRunsWithoutTaskSwitch;
